import ViewerCreditsJournal from './ViewerCreditsJournal';
import   React                      ,
       { useState                  ,
         useEffect                 ,
         useRef                    }  from 'react';

import   classNames                    from 'classnames';

import   styles                        from './UserSheetV2.module.scss';

import   Field                         from '../../widget/inputs/Field';
import   Select                        from '../../widget/inputs/Select';
import   Toggle                        from '../../widget/inputs/Toggle';
import   Trigger                       from '../../widget/actuators/Trigger';
import   WidgetFrame                   from '../../widget/navigation/WidgetFrame';
import   Window                        from '../../widget/windows/window';
import   Icon                          from '../../widget/images/Icon';

import { User                       ,
         USER_STATUS_VALUES         ,
         USER_STATUS_LABELS         ,
         USER_COUNTRY_VALUES        }  from '../../../dataTypes/userManagment/types';
import { formatDateOrDash             }  from '../../../dataTypes/userManagment/utils';
import { convertStringToDate        ,
         convertDateToString        }  from '../../../dataTypes/timeManagment/utils';

import { Validation                 ,
         checkFirstname             ,
         checkLastname              ,
         checkSex                   ,
         checkBirthday              ,
         checkAddress               ,
         checkAddress2              ,
         checkZipCode               ,
         checkCity                  ,
         checkCountry               ,
         checkPhoneNumber           } from '../../../dataTypes/userManagment/validators';

import { createUser                 ,
         patchUser                  ,
         getUserExistenceCheck      }  from '../../../backendServices/userManagment/api';

// ── Icône "Enregistrer" — même SVG que AdminSheet.tsx (Ico.Save) ──
const SaveIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14">
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
    <polyline points="17 21 17 13 7 13 7 21"/>
    <polyline points="7 3 7 8 15 8"/>
  </svg>
);

export interface UserSheetV2Props {
  user?     : User;
  onCreate? : (id: number) => void;
  onEdit?   : (id: number) => void;
}

export const UserSheetV2 = ({ user     ,
                              onCreate ,
                              onEdit   }: UserSheetV2Props) => {

  const isEditMode = user !== undefined;

  const now      = new Date();
  const nextYear = new Date(now.getFullYear()+1, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());

  // ── Compte ──
  const [ email             , setEmail             ] = useState ( user?.email ?? '' );
  const [ password          , setPassword          ] = useState ( '' );

  // ── Fenêtre de saisie du mot de passe ──
  const [ showPasswordWindow , setShowPasswordWindow ] = useState ( false );
  const [ passwordDraft1     , setPasswordDraft1     ] = useState ( '' );
  const [ passwordDraft2     , setPasswordDraft2     ] = useState ( '' );
  const [ passwordDraftError , setPasswordDraftError ] = useState ( '' );

  // ── Informations personnelles ──
  const [ firstname         , setFirstname         ] = useState ( user?.firstname ?? '' );
  const [ lastname          , setLastname          ] = useState ( user?.lastname  ?? '' );
  const [ sex               , setSex               ] = useState ( user?.sex === '' || user?.sex === undefined ? 'Aucune réponse' : user.sex );
  const [ birthday          , setBirthday          ] = useState ( user?.birthday ?? null );
  const [ phoneNumber       , setPhoneNumber       ] = useState ( user?.phoneNumber ?? '' );

  // ── Localisation ──
  const [ address           , setAddress           ] = useState ( user?.address  ?? '' );
  const [ address2          , setAddress2          ] = useState ( user?.address2 ?? '' );
  const [ zipCode           , setZipCode           ] = useState ( user?.zipCode  ?? '' );
  const [ city              , setCity              ] = useState ( user?.city     ?? '' );
  const [ country           , setCountry           ] = useState ( user?.country === '' || user?.country === undefined ? 'France' : user.country );

  // ── Statut et activités ──
  const [ status            , setStatus            ] = useState ( user?.status ?? 'Discover' );
  const [ statusDeadline    , setStatusDeadline     ] = useState ( user?.statusDeadline ?? nextYear );
  const [ locked            , setLocked             ] = useState ( user?.locked ?? false );

  const [ emailErrorMessage     , setEmailErrorMessage     ] = useState ('');
  const [ passwordErrorMessage  , setPasswordErrorMessage  ] = useState ('');
  const [ firstnameErrorMessage , setFirstnameErrorMessage ] = useState ('');
  const [ lastnameErrorMessage  , setLastnameErrorMessage  ] = useState ('');
  const [ sexErrorMessage       , setSexErrorMessage       ] = useState ('');
  const [ birthdayErrorMessage  , setBirthdayErrorMessage  ] = useState ('');
  const [ addressErrorMessage   , setAddressErrorMessage   ] = useState ('');
  const [ address2ErrorMessage  , setAddress2ErrorMessage  ] = useState ('');
  const [ zipCodeErrorMessage   , setZipCodeErrorMessage   ] = useState ('');
  const [ cityErrorMessage      , setCityErrorMessage      ] = useState ('');
  const [ countryErrorMessage   , setCountryErrorMessage   ] = useState ('');
  const [ phoneNumberErrorMessage , setPhoneNumberErrorMessage ] = useState ('');

  // Vérification en direct : l'email saisi est-il déjà pris par un autre compte ?
  useEffect(() => {

    if (email === '') { setEmailErrorMessage(''); return; }

    // L'email n'a pas changé depuis le chargement : pas de conflit avec soi-même
    if (isEditMode && user && email === user.email) { setEmailErrorMessage(''); return; }

    let cancelled = false;

    getUserExistenceCheck('email', email, isEditMode && user ? user.email : undefined).then((result) => {
      if (cancelled) return;
      setEmailErrorMessage(result.code === 1 && result.payload ? 'Cet email existe déjà' : '');
    });

    return () => { cancelled = true; };

  }, [email, isEditMode, user]);

  const [ saveButtonLock    , setSaveButtonLock    ] = useState(false);
  const [ saved             , setSaved             ] = useState(false);
  const [ error             , setError             ] = useState(false);
  const [ errorMsg          , setErrorMsg          ] = useState('');

  const handleEmailChange       = (e: React.ChangeEvent<HTMLInputElement >) => { setEmail       (e.target.value); setEmailErrorMessage     (''); };
  const handleFirstnameChange   = (e: React.ChangeEvent<HTMLInputElement >) => { setFirstname   (e.target.value); const r: Validation = checkFirstname (e.target.value); setFirstnameErrorMessage (r.comment); };
  const handleLastnameChange    = (e: React.ChangeEvent<HTMLInputElement >) => { setLastname    (e.target.value); const r: Validation = checkLastname  (e.target.value); setLastnameErrorMessage  (r.comment); };
  const handleSexChange         = (e: React.ChangeEvent<HTMLSelectElement>) => { setSex         (e.target.value); const r: Validation = checkSex       (e.target.value); setSexErrorMessage       (r.comment); };
  const handlePhoneNumberChange = async (e: React.ChangeEvent<HTMLInputElement>) => { setPhoneNumber (e.target.value); const r: Validation = await checkPhoneNumber (e.target.value, isEditMode && user ? user.email : ''); setPhoneNumberErrorMessage (r.comment); };

  const handleBirthdayChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value;
    const convertedBirthday = convertStringToDate (newDate);

    setBirthday (convertedBirthday);

    const r: Validation = checkBirthday (convertedBirthday);
    setBirthdayErrorMessage (r.comment);
  };

  const handleAddressChange  = (e: React.ChangeEvent<HTMLInputElement>) => { setAddress  (e.target.value); const r: Validation = checkAddress  (e.target.value); setAddressErrorMessage  (r.comment); };
  const handleAddress2Change = (e: React.ChangeEvent<HTMLInputElement>) => { setAddress2 (e.target.value); const r: Validation = checkAddress2 (e.target.value); setAddress2ErrorMessage (r.comment); };
  const handleZipCodeChange  = (e: React.ChangeEvent<HTMLInputElement>) => { setZipCode  (e.target.value); const r: Validation = checkZipCode  (e.target.value); setZipCodeErrorMessage  (r.comment); };
  const handleCityChange     = (e: React.ChangeEvent<HTMLInputElement>) => { setCity     (e.target.value); const r: Validation = checkCity     (e.target.value); setCityErrorMessage     (r.comment); };
  const handleCountryChange  = (e: React.ChangeEvent<HTMLSelectElement>) => { setCountry  (e.target.value); const r: Validation = checkCountry  (e.target.value); setCountryErrorMessage  (r.comment); };

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setStatus (e.target.value);
  };

  const handleStatusDeadlineChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value;
    const convertedDate = convertStringToDate(newDate);

    setStatusDeadline (convertedDate ?? nextYear);
  };

  const handleLockedChange = (value: boolean) => { setLocked (value); };

  const handlePasswordDraft1Change = (e: React.ChangeEvent<HTMLInputElement>) => { setPasswordDraft1 (e.target.value); setPasswordDraftError (''); };
  const handlePasswordDraft2Change = (e: React.ChangeEvent<HTMLInputElement>) => { setPasswordDraft2 (e.target.value); setPasswordDraftError (''); };

  const handleOpenPasswordWindow = () => {
    setPasswordDraft1     ('');
    setPasswordDraft2     ('');
    setPasswordDraftError ('');
    setShowPasswordWindow (true);
  };

  const handleCancelPasswordWindow = () => {
    setShowPasswordWindow (false);
  };

  const handleValidatePasswordWindow = () => {

    if (passwordDraft1 === '')             { setPasswordDraftError ("Le mot de passe ne peut pas être vide");  return; }
    if (passwordDraft1 !== passwordDraft2) { setPasswordDraftError ("Les mots de passe ne correspondent pas"); return; }

    setPassword             (passwordDraft1);
    setPasswordErrorMessage ('');
    setShowPasswordWindow   (false);
  };

  // ── Nombre de modifications : même mécanisme qu'AdminSheet (valeurs initiales figées via
  //    useRef au montage, recalcul à chaque rendu, pas de compteur incrémental) ──
  const initialValuesRef = useRef({
    email, firstname, lastname, sex, birthday, phoneNumber,
    address, address2, zipCode, city, country,
    status, statusDeadline, locked,
  });
  const initialValues = initialValuesRef.current;

  const nbMods = (() => {
    let n = 0;
    if (email          !== initialValues.email)          n++;
    if (password        !== '') n++;
    if (firstname       !== initialValues.firstname)      n++;
    if (lastname        !== initialValues.lastname)       n++;
    if (sex             !== initialValues.sex)             n++;
    if (birthday?.getTime() !== initialValues.birthday?.getTime()) n++;
    if (phoneNumber     !== initialValues.phoneNumber)     n++;
    if (address         !== initialValues.address)         n++;
    if (address2        !== initialValues.address2)        n++;
    if (zipCode         !== initialValues.zipCode)          n++;
    if (city            !== initialValues.city)             n++;
    if (country         !== initialValues.country)          n++;
    if (status          !== initialValues.status)           n++;
    if (statusDeadline?.getTime() !== initialValues.statusDeadline?.getTime()) n++;
    if (locked          !== initialValues.locked)            n++;
    return n;
  })();

  // ── Enregistrement (mode édition) ──
  const handleSaveButton = async () => {

    if (!user || saveButtonLock || emailErrorMessage !== '' || nbMods === 0) return;

    const emailErrorMessageBis = email === '' ? "Il manque l'e-mail" : '';
    setEmailErrorMessage(emailErrorMessageBis);
    if (emailErrorMessageBis !== '') return;

    setSaveButtonLock(true);

    const result = await patchUser ( user.id , email,
                                     firstname , lastname , sex , birthday ,
                                     address , address2 , zipCode , city , country , phoneNumber ,
                                     status , statusDeadline , locked ,
                                     password );

    setSaved(true);
    setError(result.code !== 1);

    if (result.code !== 1) { setErrorMsg(result.comment); }
    else                   { setPassword(''); }

    setSaveButtonLock(false);
  };

  // ── Création ──
  const handleCreateButton = async () => {

    if (saveButtonLock) return;

    const emailErrorMessageBis     = email     === '' ? "Il manque l'e-mail"        : emailErrorMessage;
    const passwordErrorMessageBis  = password  === '' ? "Il manque le mot de passe" : '';
    const firstnameErrorMessageBis = firstname === '' ? "Il manque le prénom"       : '';
    const lastnameErrorMessageBis  = lastname  === '' ? "Il manque le nom"          : '';

    setEmailErrorMessage    (emailErrorMessageBis);
    setPasswordErrorMessage (passwordErrorMessageBis);
    setFirstnameErrorMessage(firstnameErrorMessageBis);
    setLastnameErrorMessage (lastnameErrorMessageBis);

    const test = emailErrorMessageBis     === '' &&
                 passwordErrorMessageBis  === '' &&
                 firstnameErrorMessageBis === '' &&
                 lastnameErrorMessageBis  === '';

    if (!test) return;

    setSaveButtonLock(true);

    const result = await createUser (email, password, firstname, lastname, sex, birthday);

    if (result.code === 1)
     {
      // Applique les champs non gérés par la création (localisation, statut, verrouillage…) —
      // patchUser couvre déjà tous ces champs à l'identique pour l'édition.
      await patchUser ( result.payload , email,
                        firstname , lastname , sex , birthday ,
                        address , address2 , zipCode , city , country , phoneNumber ,
                        status , statusDeadline , locked );

      setSaved(true);
      setError(false);
     }
    else
     {
      setSaved(true);
      setError(true);
      setErrorMsg(result.comment);
     }

    setSaveButtonLock(false);
  };

  const handleInformationWindowClosure = () => {

    setSaved(false);

    if (error) return;

    if (!isEditMode && onCreate)        onCreate(0);
    if ( isEditMode && user && onEdit)  onEdit(user.id);
  };

  const handleReturnButton = () => {

    if (isEditMode && user && onEdit) onEdit(user.id);
  };

  return (
    <div className={classNames(styles.root)}>

      {
       saved &&
       (
        <Window message                 = {
                                           error
                                           ? <>Une erreur est survenue lors de {isEditMode ? 'la mise à jour' : 'la création'} du compte{errorMsg ? <> : {errorMsg}</> : null}</>
                                           : <>{isEditMode ? 'Compte mis à jour' : 'Compte créé'}</>
                                          }
                messageType             = "information"
                validButtonText         = "Ok"
                onClickOnValidateButton = {handleInformationWindowClosure} />
       )
      }

      {
       showPasswordWindow &&
       (
        <>
          <div className={classNames(styles.passwordOverlay)} />
          <div className={classNames(styles.passwordWindow)}>

            <div className={classNames(styles.passwordWindowTitle)}>Nouveau mot de passe</div>

            <Field type="password" placeholder="Mot de passe" value={passwordDraft1} onChange={handlePasswordDraft1Change} eyeVisible={true} />
            <Field type="password" placeholder="Confirmation" value={passwordDraft2} onChange={handlePasswordDraft2Change} eyeVisible={true} />

            {
             passwordDraftError !== '' &&
             <p className={classNames(styles.alert)}>{passwordDraftError}</p>
            }

            <div className={classNames(styles.passwordWindowButtons)}>
              <Trigger name="Annuler" onClick={handleCancelPasswordWindow}    variant="tailwind2" />
              <Trigger name="Valider" onClick={handleValidatePasswordWindow} variant="tailwind2" />
            </div>

          </div>
        </>
       )
      }

      <div className={classNames(styles.head)}>
        <span className={classNames(styles.headIcon)}>
          <Icon name="user" color="#4992FA" hoverable={false} clickable={false} width={20} height={20} />
        </span>
        <div className={classNames(styles.headTitleBlock)}>
          <span className={classNames(styles.headTitle)}>{isEditMode ? 'Compte utilisateur' : 'Nouveau compte utilisateur'}</span>
          <span className={classNames(styles.headSubtitle)}>
            Créez ou modifiez les informations du compte utilisateur
          </span>
        </div>
        <div className={classNames(styles.headActions)}>
          {
           nbMods > 0 &&
           <span className={classNames(styles.modBadge)}>{nbMods} modification{nbMods > 1 ? 's' : ''}</span>
          }
          {
           isEditMode
           ? <>
               <button className={classNames(styles.btn, styles.btnOutline)} onClick={handleReturnButton}>Retour</button>
               <button className={classNames(styles.btn, nbMods > 0 ? styles.btnSave : styles.btnPrimary)}
                       onClick={handleSaveButton}
                       disabled={saveButtonLock}>
                 <SaveIcon/>
                 {saveButtonLock ? 'Enregistrement…' : 'Enregistrer'}{!saveButtonLock && nbMods > 0 && ` (${nbMods})`}
               </button>
             </>
           : <button className={classNames(styles.btn, nbMods > 0 ? styles.btnSave : styles.btnPrimary)}
                     onClick={handleCreateButton}
                     disabled={saveButtonLock}>
               <SaveIcon/>
               {saveButtonLock ? 'Création…' : 'Créer'}{!saveButtonLock && nbMods > 0 && ` (${nbMods})`}
             </button>
          }
        </div>
      </div>

      <div className={classNames(styles.block)}>

        <div className={classNames(styles.metaGrid)}>
          <WidgetFrame name                  = "ID :"
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "left"
					   labelWidth            = '30px'
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <p className={classNames(styles.text)}>{isEditMode && user ? user.id : '—'}</p>
          </WidgetFrame>

          <WidgetFrame name                  = "Date de création :"
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "left"
                       labelWidth            = '130px'
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <p className={classNames(styles.text)}>{isEditMode && user ? formatDateOrDash(user.creationDate) : '—'}</p>
          </WidgetFrame>

          <WidgetFrame name                  = "Dernière modification :"
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "left"
                       labelWidth            = '165px'
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <p className={classNames(styles.text)}>{isEditMode && user ? formatDateOrDash(user.lastUpdateDate) : '—'}</p>
          </WidgetFrame>
        </div>
      </div>

      {/* ══ Grille : informations personnelles / localisation (gauche) / statut (droite, pleine hauteur) ══ */}
      <div className={classNames(styles.topGrid)}>

        <div className={classNames(styles.block, styles.areaPersonal)}>
          <div className={classNames(styles.blockTitle)}><div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="privatePersonnalInfos" color="#2563EB" hoverable={false} clickable={false}/> <span>Informations personnelles</span> </div></div>

          <div className={classNames(styles.nameRow)}>
            <WidgetFrame name               = "Prénom :"
                         error              = {firstnameErrorMessage}
                         labelTextPosition  = "left"
                         labelBlockPosition = "left"
                         labelWidth         = '70px'
                         classNameGrid      = {classNames(styles.grid_frame)}>
              <Field type="text" placeholder="" value={firstname} onChange={handleFirstnameChange} />
            </WidgetFrame>

            <WidgetFrame name               = "Nom :"
                         error              = {lastnameErrorMessage}
                         labelTextPosition  = "left"
                         labelBlockPosition = "left"
                         labelWidth         = '45px'
                         classNameGrid      = {classNames(styles.grid_frame)}>
              <Field type="text" placeholder="" value={lastname} onChange={handleLastnameChange} />
            </WidgetFrame>
          </div>

          <div className={classNames(styles.nameRow)}>
            <WidgetFrame name               = "Email :"
                         error              = {emailErrorMessage}
                         labelTextPosition  = "left"
                         labelBlockPosition = "left"
                         labelWidth         = '70px'
                         labelVerticalAlign = "center"
                         classNameGrid      = {classNames(styles.grid_frame)}>
              <Field type="text" placeholder="" value={email} onChange={handleEmailChange} />
            </WidgetFrame>

            <div className={classNames(styles.btnPass)}>
              <Trigger name='mot de passe' onClick={handleOpenPasswordWindow} variant="tailwind2" />
            </div>
          </div>

          {
           !isEditMode && passwordErrorMessage !== '' &&
           <p className={classNames(styles.alert)}>{passwordErrorMessage}</p>
          }

            <WidgetFrame name               = "Sexe :"
                         error              = {sexErrorMessage}
                         labelTextPosition  = "left"
                         labelBlockPosition = "left"
                         labelWidth         = '50px'
                         classNameGrid      = {classNames(styles.grid_frame)}>
              <Select choices      = { [ "Aucune réponse" , "Homme" , "Femme" ] }
                      value        = {sex}
                      onChange     = {handleSexChange} />
            </WidgetFrame>

            <WidgetFrame name               = "Date de naissance :"
                         error              = {birthdayErrorMessage}
                         labelTextPosition  = "left"
                         labelBlockPosition = "left"
                         labelWidth         = '140px'
                         classNameGrid      = {classNames(styles.grid_frame)}>
              <Field value      = {birthday ? convertDateToString (birthday, 'dd/MM/yyyy') : ''}
                     onChange   = {handleBirthdayChange}
                     type       = "calendar"
                     dateFormat = 'dd/MM/yyyy' />
            </WidgetFrame>

          <WidgetFrame name               = "Téléphone :"
                       error              = {phoneNumberErrorMessage}
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       labelWidth         = '140px'
                       classNameGrid      = {classNames(styles.grid_frame)}>
            <Field type="text" placeholder="" value={phoneNumber} onChange={handlePhoneNumberChange} />
          </WidgetFrame>

        </div>

        <div className={classNames(styles.block, styles.areaLocal)}>
          <div className={classNames(styles.blockTitle)}><div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="localisation" color="#2563EB" hoverable={false} clickable={false}/> <span>Localisation</span> </div></div>

          <WidgetFrame name               = "Adresse :"
                       error              = {addressErrorMessage}
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       labelWidth         = '100px'
                       classNameGrid      = {classNames(styles.grid_frame)}>
            <Field type="text" placeholder="" value={address} onChange={handleAddressChange} />
          </WidgetFrame>

          <WidgetFrame name               = "Complément :"
                       error              = {address2ErrorMessage}
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       labelWidth         = '100px'
                       classNameGrid      = {classNames(styles.grid_frame)}>
            <Field type="text" placeholder="" value={address2} onChange={handleAddress2Change} />
          </WidgetFrame>

          <div className={classNames(styles.nameRow)}>
            <WidgetFrame name               = "Code postal :"
                         error              = {zipCodeErrorMessage}
                         labelTextPosition  = "left"
                         labelBlockPosition = "left"
                         labelWidth         = '100px'
                         classNameGrid      = {classNames(styles.grid_frame)}>
              <Field type="text" placeholder="" value={zipCode} onChange={handleZipCodeChange} />
            </WidgetFrame>

            <WidgetFrame name               = "Ville :"
                         error              = {cityErrorMessage}
                         labelTextPosition  = "left"
                         labelBlockPosition = "left"
                         labelWidth         = '45px'
                         classNameGrid      = {classNames(styles.grid_frame)}>
              <Field type="text" placeholder="" value={city} onChange={handleCityChange} />
            </WidgetFrame>
          </div>

          <WidgetFrame name               = "Pays :"
                       error              = {countryErrorMessage}
                       labelTextPosition  = "left"
                       labelBlockPosition = "left"
                       labelWidth         = '100px'
                       classNameGrid      = {classNames(styles.grid_frame)}>
            <Select choices  = {USER_COUNTRY_VALUES}
                    value    = {country}
                    onChange = {handleCountryChange} />
          </WidgetFrame>

        </div>

        <div className={classNames(styles.block, styles.areaStatut)}>
          <div className={classNames(styles.blockTitle)}><div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="growth" color="#2563EB" hoverable={false} clickable={false}/> <span>Statut et activités</span> </div></div>

          <WidgetFrame name                  = {<div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="growth" color="#2563EB" hoverable={false} clickable={false}/> <span>Statut :</span> </div>}
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "right"
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <div className={classNames(styles.statusWithDeadline)}>
              <Select choices          = {USER_STATUS_VALUES}
                      choicesLabel     = {USER_STATUS_LABELS}
                      value            = {status}
                      showPlaceholder  = {false}
                      onChange         = {handleStatusChange} />
              &nbsp;&nbsp;
              {
               ( status === 'Standard' || status === 'Premium' ) &&
               <Field value      = { statusDeadline ? convertDateToString ( statusDeadline , 'dd/MM/yyyy' ) : '' }
                      onChange   = { handleStatusDeadlineChange }
                      type       = "calendar"
                      dateFormat = "dd/MM/yyyy" />
              }
            </div>
          </WidgetFrame>

          <WidgetFrame name                  = {<div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="lockedPadlock" color="#2563EB" hoverable={false} clickable={false}/> <span>Verrouillé :</span> </div>}
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "right"
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <Toggle checked={locked} onChange={handleLockedChange} form="switch" invertColor={true} />
          </WidgetFrame>

          <WidgetFrame name                  = {<div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="clock" color="#2563EB" hoverable={false} clickable={false}/> <span>Dernière connexion :</span> </div>}
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "right"
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <p className={classNames(styles.text)}>{isEditMode && user ? formatDateOrDash(user.lastLoginDate) : '—'}</p>
          </WidgetFrame>

          <WidgetFrame name                  = {<div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="internet" color="#2563EB" hoverable={false} clickable={false}/> <span>IP dernière connexion :</span> </div>}
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "right"
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <p className={classNames(styles.text)}>{(isEditMode && user?.lastLoginIpAddress) || '—'}</p>
          </WidgetFrame>

          <WidgetFrame name                  = {<div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="pinOnMap" color="#2563EB" hoverable={false} clickable={false}/> <span>Ville de connexion :</span> </div>}
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "right"
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <p className={classNames(styles.text)}>{(isEditMode && user?.lastLoginCity) || '—'}</p>
          </WidgetFrame>

          <WidgetFrame name                  = {<div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="internet" color="#2563EB" hoverable={false} clickable={false}/> <span>IP création :</span> </div>}
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "right"
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <p className={classNames(styles.text)}>{(isEditMode && user?.creationIpAddress) || '—'}</p>
          </WidgetFrame>

          <WidgetFrame name                  = {<div style={{ display: "flex", alignItems: "center", gap: "10px" }} > <Icon name="pinOnMap" color="#2563EB" hoverable={false} clickable={false}/> <span>Ville de création :</span> </div>}
                       labelTextPosition     = "left"
                       labelBlockPosition    = "left"
                       childrenBlockPosition = "right"
                       classNameGrid         = {classNames(styles.grid_frame)}>
            <p className={classNames(styles.text)}>{(isEditMode && user?.ipApiCom_city) || '—'}</p>
          </WidgetFrame>

        </div>

        {isEditMode && user && <ViewerCreditsJournal userId={user.id} />}

      </div>

    </div>
  );
};

export default UserSheetV2;
